import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Moment from 'moment';
import { clearSearch, getConversations, searchConversation, stageConversation } from 'actions/conversation';
import { setPageTitle } from 'actions/header';
import { getConversationParticipants } from '../Helpers';
import Modal from 'containers/Modals/Modal';
import SelectRecipientForm from '../Form/SelectRecipient';
import { Person, Spinner, Collapsible } from 'UI';
import { Search } from 'UI/Inputs';
import { Button, Flex, translate } from '@haldor/ui';
import '../Conversation.scss';
var ConversationsPage = /*#__PURE__*/function (_Component) {
  /* Class setup */
  function ConversationsPage(props) {
    var _this;
    _classCallCheck(this, ConversationsPage);
    _this = _callSuper(this, ConversationsPage, [props]);
    /* Lifecycle events */
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.setState({
        loading: true
      });
      _this.props.setPageTitle(_this.props.translate('Messages'));
      _this.props.getConversations(_this.props.activeStudent.id).then(function () {
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.props.clearSearch();
    });
    /* Events */
    _defineProperty(_this, "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });
    _defineProperty(_this, "getConversations", function () {
      _this.props.clearSearch();
      _this.setState({
        loading: true
      });
      _this.props.getConversations(_this.props.activeStudent.id).then(function () {
        _this.setState({
          loading: false
        });
      });
    });
    _defineProperty(_this, "onSelectRecipients", function (values) {
      // Create conversation API request hereee
      var conversation = {
        title: '',
        status: 'ACTIVE',
        memberships: values.memberships,
        messages: [],
        relationships: values.relationships,
        id: 'new'
      };
      _this.props.stageConversation(conversation).then(function () {
        _this.setState({
          modal: false
        });
        _this.props.history.push("/conversations/new");
      });
    });
    _defineProperty(_this, "onSearch", function (query) {
      if (query.query.length == 0) {
        _this.getConversations();
        return;
      }
      if (query.query.length < 2) {
        _this.props.clearSearch();
        return;
      }
      _this.setState({
        searching: true
      });
      _this.props.searchConversation(query.query, _this.props.activeStudent.id).then(function () {
        _this.setState({
          searching: false
        });
      });
    });
    /* Render methods */
    _defineProperty(_this, "renderConversation", function (conversation, index) {
      var participants = getConversationParticipants(conversation, _this.props.user);
      var message = null;
      var timeOfLastMessage = null;
      if (conversation.messages.length > 0 && conversation.messages[conversation.messages.length - 1] != null) {
        var lastMessage = conversation.messages[conversation.messages.length - 1];
        timeOfLastMessage = lastMessage.created;
        if (lastMessage.flagID != null) {
          message = /*#__PURE__*/React.createElement("span", {
            style: {
              fontStyle: 'italic'
            }
          }, _this.props.translate('Message is reported as inappropriate.'));
        } else {
          message = lastMessage.text.replace(/(<([^>]+)>)/ig, '');
          if (message.length > 155) {
            message = message.substring(0, 155) + '...';
          }
        }
      }
      return /*#__PURE__*/React.createElement(Link, {
        key: index,
        to: "/conversations/".concat(conversation.id),
        className: "conversation-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "participants"
      }, participants.map(function (participant) {
        if (participant.membershipType == 'SECTION_OWNERS') {
          return /*#__PURE__*/React.createElement(Person, {
            person: _objectSpread({
              firstName: participant.title + " (" + _this.props.translate("Staff") + ")",
              lastName: ''
            }, participant),
            key: participant.id
          });
        }
        return /*#__PURE__*/React.createElement(Person, {
          person: participant,
          key: participant.userId
        });
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "latest-message"
      }, conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("span", {
        className: "badge",
        style: {
          display: 'inline-flex',
          transform: 'none',
          position: 'static',
          justifyContent: 'center',
          borderRadius: '100%',
          marginRight: '0.4rem'
        }
      }, conversation.unreadMessages) : null, message ? message : null), timeOfLastMessage != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginTop: '-1.5rem',
          "float": 'right'
        }
      }, Moment.utc(timeOfLastMessage).local().format('yyyy-MM-DD HH:mm')) : null));
    });
    _this.state = {
      modal: false,
      searching: false,
      loading: false
    };
    return _this;
  }
  _inherits(ConversationsPage, _Component);
  return _createClass(ConversationsPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.activeStudent == null || !this.props.activeStudent.services.conversations || this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      var conversations = null;
      var archived = null;
      if (this.props.conversations != null && this.props.conversations.length > 0) {
        conversations = JSON.parse(JSON.stringify(this.props.conversations)).filter(function (conversation) {
          return conversation.status != 'ARCHIVED';
        });
        archived = JSON.parse(JSON.stringify(this.props.conversations)).filter(function (conversation) {
          return conversation.status == 'ARCHIVED';
        });
      }
      if (this.props.results != null && this.props.results.length > 0) {
        conversations = JSON.parse(JSON.stringify(this.props.results)).filter(function (conversation) {
          return conversation.status != 'ARCHIVED';
        });
        archived = JSON.parse(JSON.stringify(this.props.results)).filter(function (conversation) {
          return conversation.status == 'ARCHIVED';
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "page"
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: this.toggleModal,
        title: this.props.translate('Select recipient'),
        isOpen: this.state.modal,
        type: "small"
      }, /*#__PURE__*/React.createElement(SelectRecipientForm, {
        onSubmit: this.onSelectRecipients
      })), /*#__PURE__*/React.createElement("div", {
        className: "create-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleModal
      }, this.props.translate('Write new'))), /*#__PURE__*/React.createElement("div", {
        className: "conversation conversation--wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "conversation-list"
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1'
        }
      }, /*#__PURE__*/React.createElement(Search, {
        onSubmit: this.onSearch,
        loading: this.state.searching,
        placeholder: this.props.translate('Search conversations'),
        autoSearch: true,
        allowEmpty: true
      }))), conversations != null ? conversations.map(function (conversation, index) {
        return _this2.renderConversation(conversation, index);
      }) : null, archived != null && archived.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "archived-conversations"
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: this.props.translate('Removed')
      }, archived.map(function (conversation, index) {
        return _this2.renderConversation(conversation, index);
      }))) : null)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    conversations: state.Conversation.conversations,
    activeStudent: state.User.activeStudent,
    user: state.User.user,
    results: state.Conversation.searchResults,
    currentStudent: state.guardians.currentStudent,
    translate: translate(state.Languages.translations)
  };
}
export default withRouter(connect(mapStateToProps, {
  getConversations: getConversations,
  stageConversation: stageConversation,
  searchConversation: searchConversation,
  clearSearch: clearSearch,
  setPageTitle: setPageTitle
})(ConversationsPage));